module.exports = __webpack_public_path__ + "img/toward.8ddde4ed.svg";